import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ResponseInterceptor from "./services/ResponseInterceptor";
import ScrollToTop from "./components/common/ScrollToTop";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
   <React.StrictMode>

  <BrowserRouter>
    <ResponseInterceptor></ResponseInterceptor>
    <ScrollToTop />
    <App />
  </BrowserRouter>

   </React.StrictMode>
);
